import validate from "/home/runner/work/delight.ai/delight.ai/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/delight.ai/delight.ai/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "page-section-handle": () => import("/home/runner/work/delight.ai/delight.ai/frontend/middleware/page-section-handle.ts")
}